/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export {
  StyledBreadCrumbContainer,
  StyledLink,
  filterContainerStyles,
  selectBaseStyles,
  datePickerStyles,
} from "../classified_discount_records/styles";

export { dropdownMenuProps } from "../perq_report/styles";

export const DAILY_LOGBOOK_COLORS = {
  negative: "#FF0000",
  positive: "#0F8A4C",
};

const ACTION_BLUE = "#2b4fb9";
const ACTION_BLUE_HOVER = "#24409a";

export const negativeCellStyles = {
  color: DAILY_LOGBOOK_COLORS.negative,
  fontWeight: 600,
};

export const positiveVarianceStyles = {
  color: DAILY_LOGBOOK_COLORS.positive,
  fontWeight: 600,
};

export const comparisonLegendStyles = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "6px 10px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#3f3f46",
  padding: "10px 16px",
  marginBottom: "16px",
  backgroundColor: "#f7f7f7",
  border: "1px solid #eee",
  borderRadius: "8px",
};

export const comparisonLegendSeparatorStyles = {
  color: "#d4d4d8",
};

export const drillInPaperBaseStyles = {
  borderRadius: "16px",
};

export const detailsModalPaperStyles = {
  ...drillInPaperBaseStyles,
  height: "85vh",
  maxHeight: "85vh",
};

export const drillInHeaderStyles = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "12px",
  padding: "22px 28px 16px",
  borderBottom: "1px solid #e5e7eb",
};

export const drillInTitleStyles = {
  fontSize: "20px",
  fontWeight: 700,
  color: "#111827",
  lineHeight: 1.2,
};

export const drillInCloseButtonStyles = {
  color: "#6b7280",
  marginTop: "-4px",
};

export const drillInHeaderActionsStyles = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexShrink: 0,
};

export const drillInExportButtonStyles = {
  textTransform: "none",
  fontSize: "13px",
  fontWeight: 600,
  whiteSpace: "nowrap",
  borderRadius: "8px",
  color: ACTION_BLUE,
  borderColor: ACTION_BLUE,
  "&:hover": { borderColor: ACTION_BLUE_HOVER, backgroundColor: "#f4f7ff" },
};

export const detailsModalContentStyles = {
  "&.MuiDialogContent-root": {
    padding: 0,
    display: "flex",
    overflow: "hidden",
  },
};

export const detailsModalColumnsStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  width: "100%",
  minHeight: 0,
  overflowY: { xs: "auto", md: "hidden" },
};

export const detailsModalLeftColumnStyles = {
  width: { xs: "100%", md: "38%" },
  flexShrink: 0,
  minHeight: 0,
  minWidth: 0,
  overflowY: { xs: "visible", md: "auto" },
  overflowX: "hidden",
  borderRight: { md: "1px solid #eee" },
  borderBottom: { xs: "1px solid #eee", md: "none" },
  padding: "20px 24px",
  boxSizing: "border-box",
};

export const detailsModalRightColumnStyles = {
  flex: { xs: "0 0 auto", md: 1 },
  minWidth: 0,
  minHeight: 0,
  overflowY: { xs: "visible", md: "auto" },
  overflowX: "hidden",
  padding: "20px 24px",
  boxSizing: "border-box",
};

export const panelHeadingStyles = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#3f3f46",
  marginBottom: "10px",
};

export const panelCountStyles = {
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: 0,
  color: "#a1a1aa",
};

export const metricGridStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginBottom: "20px",
};

export const metricCardStyles = {
  border: "1px solid #eee",
  borderRadius: "8px",
  padding: "10px 12px",
  backgroundColor: "#fff",
  minWidth: 0,
  overflow: "hidden",
  boxSizing: "border-box",
};

export const allocatedMetricCardStyles = {
  ...metricCardStyles,
  borderStyle: "dashed",
  borderColor: "#fdba74",
  backgroundColor: "#fff8f1",
};

export const metricLabelStyles = {
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "12px",
  fontWeight: 500,
  color: "#71717a",
};

export const metricValueStyles = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#18181b",
  marginTop: "2px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const revenueCenterCardStyles = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  overflow: "hidden",
  textAlign: "left",
  border: "1px solid #eee",
  borderRadius: "8px",
  padding: "10px 12px",
  marginBottom: "8px",
  backgroundColor: "#fff",
  cursor: "pointer",
  transition: "background-color 0.2s ease, box-shadow 0.2s ease",
  "&:hover": { backgroundColor: "#fafcff", boxShadow: "inset 0 0 0 1px #d7e3ff" },
  "&:focus-visible": { outline: "2px solid #d7e3ff", outlineOffset: "1px" },
};

export const revenueCenterNameStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#18181b",
};

export const revenueCenterNameTextStyles = {
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const revenueCenterFiguresStyles = {
  display: "flex",
  flexWrap: "wrap",
  gap: "4px 14px",
  fontSize: "12px",
  color: "#71717a",
  marginTop: "4px",
  minWidth: 0,
  maxWidth: "100%",
};

export const sectionCardStyles = {
  border: "1px solid #eee",
  borderRadius: "8px",
  marginBottom: "16px",
  backgroundColor: "#fff",
  overflow: "hidden",
};

export const sectionHeaderStyles = {
  position: "sticky",
  top: 0,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 14px",
  backgroundColor: "#f7f7f7",
  borderBottom: "1px solid #eee",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#3f3f46",
};

export const sectionRowStyles = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "12px",
  padding: "10px 14px",
  borderBottom: "1px solid #f4f4f5",
  "&:last-of-type": { borderBottom: "none" },
};

export const sectionRowPrimaryStyles = {
  fontSize: "13px",
  fontWeight: 500,
  color: "#18181b",
};

export const sectionRowSecondaryStyles = {
  fontSize: "12px",
  color: "#71717a",
  marginTop: "2px",
};

export const sectionRowValueStyles = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#18181b",
  whiteSpace: "nowrap",
};

export const sectionEmptyStyles = {
  padding: "16px 14px",
  fontSize: "13px",
  color: "#71717a",
};

export const sectionFooterStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  padding: "10px 14px",
  borderTop: "1px solid #eee",
  backgroundColor: "#fbfbfb",
  fontSize: "12px",
  fontWeight: 600,
  color: "#3f3f46",
};

export const sectionFootnoteStyles = {
  padding: "8px 14px 12px",
  fontSize: "11px",
  lineHeight: 1.4,
  color: "#a1a1aa",
};

export const sectionShowAllStyles = {
  padding: "10px 14px",
  borderTop: "1px solid #f4f4f5",
  fontSize: "12px",
  fontWeight: 600,
  color: "#1d4ed8",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#fafcff" },
  "&:focus-visible": { outline: "2px solid #d7e3ff", outlineOffset: "-2px" },
};

export const modalMessageStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: "40px 24px",
  fontSize: "13px",
  color: "#71717a",
  textAlign: "center",
};

export const modalSubtitleStyles = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#64748b",
  marginTop: "4px",
};
